export const CookieName = "friend_katta_admin_security"

export const Per_Page_Dropdown = async (data) => {
  const a = [];
  for (let i = 10; i <= data; i *= 2) {
    a.push(i);
  }
  a.push(data);

  return a;
};

export const RequestStatus = {
  Processing: 1,
  Accepted: 2,
  Rejected: 3,
};

export const users_type = {
  admin: "admin",
  customers: "customers",
  agents: "agents",
};

export const ImageValidation = {
  files_type: ["jpg", "png", "jpeg"],
  product: { w: 578, h: 762 },
};

export const HTTPS = {
  // Informational responses (100–199)
  CONTINUE: { code: 100, message: "Continue" },
  SWITCHING_PROTOCOLS: { code: 101, message: "Switching Protocols" },
  PROCESSING: { code: 102, message: "Processing" }, // WebDAV
  EARLY_HINTS: { code: 103, message: "Early Hints" },

  // Successful responses (200–299)
  OK: { code: 200, message: "OK" },
  CREATED: { code: 201, message: "Created" },
  ACCEPTED: { code: 202, message: "Accepted" },
  NON_AUTHORITATIVE_INFORMATION: {
    code: 203,
    message: "Non-Authoritative Information",
  },
  NO_CONTENT: { code: 204, message: "No Content" },
  RESET_CONTENT: { code: 205, message: "Reset Content" },
  PARTIAL_CONTENT: { code: 206, message: "Partial Content" },
  MULTI_STATUS: { code: 207, message: "Multi-Status" }, // WebDAV
  ALREADY_REPORTED: { code: 208, message: "Already Reported" }, // WebDAV
  IM_USED: { code: 226, message: "IM Used" }, // HTTP Delta encoding

  // Redirection messages (300–399)
  MULTIPLE_CHOICES: { code: 300, message: "Multiple Choices" },
  MOVED_PERMANENTLY: { code: 301, message: "Moved Permanently" },
  FOUND: { code: 302, message: "Found" },
  SEE_OTHER: { code: 303, message: "See Other" },
  NOT_MODIFIED: { code: 304, message: "Not Modified" },
  USE_PROXY: { code: 305, message: "Use Proxy" },
  TEMPORARY_REDIRECT: { code: 307, message: "Temporary Redirect" },
  PERMANENT_REDIRECT: { code: 308, message: "Permanent Redirect" },

  // Client error responses (400–499)
  BAD_REQUEST: { code: 400, message: "Bad Request" },
  UNAUTHORIZED: { code: 401, message: "Unauthorized" },
  PAYMENT_REQUIRED: { code: 402, message: "Payment Required" },
  FORBIDDEN: { code: 403, message: "Forbidden" },
  NOT_FOUND: { code: 404, message: "Not Found" },
  METHOD_NOT_ALLOWED: { code: 405, message: "Method Not Allowed" },
  NOT_ACCEPTABLE: { code: 406, message: "Not Acceptable" },
  PROXY_AUTHENTICATION_REQUIRED: {
    code: 407,
    message: "Proxy Authentication Required",
  },
  REQUEST_TIMEOUT: { code: 408, message: "Request Timeout" },
  CONFLICT: { code: 409, message: "Conflict" },
  GONE: { code: 410, message: "Gone" },
  LENGTH_REQUIRED: { code: 411, message: "Length Required" },
  PRECONDITION_FAILED: { code: 412, message: "Precondition Failed" },
  PAYLOAD_TOO_LARGE: { code: 413, message: "Payload Too Large" },
  URI_TOO_LONG: { code: 414, message: "URI Too Long" },
  UNSUPPORTED_MEDIA_TYPE: { code: 415, message: "Unsupported Media Type" },
  RANGE_NOT_SATISFIABLE: { code: 416, message: "Range Not Satisfiable" },
  EXPECTATION_FAILED: { code: 417, message: "Expectation Failed" },
  IM_A_TEAPOT: { code: 418, message: "I'm a teapot" }, // Just for fun
  MISDIRECTED_REQUEST: { code: 421, message: "Misdirected Request" },
  UNPROCESSABLE_ENTITY: { code: 422, message: "Unprocessable Entity" }, // WebDAV
  LOCKED: { code: 423, message: "Locked" }, // WebDAV
  FAILED_DEPENDENCY: { code: 424, message: "Failed Dependency" }, // WebDAV
  TOO_EARLY: { code: 425, message: "Too Early" },
  UPGRADE_REQUIRED: { code: 426, message: "Upgrade Required" },
  PRECONDITION_REQUIRED: { code: 428, message: "Precondition Required" },
  TOO_MANY_REQUESTS: { code: 429, message: "Too Many Requests" },
  REQUEST_HEADER_FIELDS_TOO_LARGE: {
    code: 431,
    message: "Request Header Fields Too Large",
  },
  UNAVAILABLE_FOR_LEGAL_REASONS: {
    code: 451,
    message: "Unavailable For Legal Reasons",
  },

  // Server error responses (500–599)
  INTERNAL_SERVER_ERROR: { code: 500, message: "Internal Server Error" },
  NOT_IMPLEMENTED: { code: 501, message: "Not Implemented" },
  BAD_GATEWAY: { code: 502, message: "Bad Gateway" },
  SERVICE_UNAVAILABLE: { code: 503, message: "Service Unavailable" },
  GATEWAY_TIMEOUT: { code: 504, message: "Gateway Timeout" },
  HTTP_VERSION_NOT_SUPPORTED: {
    code: 505,
    message: "HTTP Version Not Supported",
  },
  VARIANT_ALSO_NEGOTIATES: { code: 506, message: "Variant Also Negotiates" },
  INSUFFICIENT_STORAGE: { code: 507, message: "Insufficient Storage" }, // WebDAV
  LOOP_DETECTED: { code: 508, message: "Loop Detected" }, // WebDAV
  NOT_EXTENDED: { code: 510, message: "Not Extended" },
  NETWORK_AUTHENTICATION_REQUIRED: {
    code: 511,
    message: "Network Authentication Required",
  },
};

export const RequiredIs = {
  roles: [1],
};

export const Select2Data = async (data, name, other = false) => {
  const result = data.map((data) => ({
    value: data?.id,
    label: data?.name,
    name: name,
  }));

  if (other) {
    result.push({ value: "0", label: "Other", name: name });
  }
  return result;
};

export const getDimension = async (file) => {
  let reader = new FileReader();
  return new Promise((resolve, reject) => {
    reader.onerror = () => {
      reader.abort();
      reject(new DOMException("Problem parsing input file."));
    };

    reader.onload = () => {
      var image = new Image();
      image.src = reader.result;
      image.onload = function () {
        resolve({ width: this.width, height: this.height });
      };
    };
    reader.readAsDataURL(file);
  });
};

export function formatDate(dateString) {
  const date = new Date(dateString);
  return date.toISOString().split("T")[0];
}

export function formatAmount(amount = 0) {
  return `₹ ${new Intl.NumberFormat("en-IN", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(Number(amount) || 0)}`;
};

export const IDS = {
  Role: { List: 1, Add: 2, Edit: 3, Delete: 4 },
  User: { List: 5, Add: 6, Edit: 7, Delete: 8 },
  Country: { List: 9, Add: 10, Edit: 11, Delete: 12 },
  State: { List: 13, Add: 14, Edit: 15, Delete: 16 },
  City: { List: 17, Add: 18, Edit: 19, Delete: 20 },
  Pincode: { List: 21, Add: 22, Edit: 23, Delete: 24 },
  CountryCode: { List: 25, Add: 26, Edit: 27, Delete: 28 },
  Category: { List: 29, Add: 30, Edit: 31, Delete: 32 },
  SubCategory: { List: 33, Add: 34, Edit: 35, Delete: 36 },
  HomeBanner: { List: 37, Add: 38, Edit: 39, Delete: 40 },
  HomeMotivatedBy: { List: 41, Add: 42, Edit: 43, Delete: 44 },
  FAQList: { List: 45, Add: 46, Edit: 47, Delete: 48 },
  AddOn: { List: 49, Add: 50, Edit: 51, Delete: 52 },
  AdditionalSupport: { List: 53, Add: 54, Edit: 55, Delete: 56 },
  BookingCancelReason: { List: 57, Add: 58, Edit: 59, Delete: 60 },
  WhyFNS: { List: 61, Add: 62, Edit: 63, Delete: 64 },
  AboutUsBanner: { List: 65, Add: 66, Edit: 67, Delete: 68 },
  OurVissionMission: { List: 69, Add: 70, Edit: 71, Delete: 72 },
  AppSetup: { List: 73, Add: 74, Edit: 75, Delete: 76 },
  SocialMedia: { List: 77, Add: 78, Edit: 79, Delete: 80 },
  HomeAboutUs: { List: 83, Add: 84, Edit: 85, Delete: 86 },
  OurTeam: { List: 87, Add: 88, Edit: 89, Delete: 90 },
  PrivacyPolicy: { List: 91, Add: 92, Edit: 93, Delete: 94 },
  TermsConditions: { List: 95, Add: 96, Edit: 97, Delete: 98 },
  Studio: { List: 99, Add: 100, Edit: 101, Delete: 102 },
  Special: { List: 126, Add: 127, Edit: 128, Delete: 129 },
  StudioBooking: { List: 103 },
  ContactUs: { List: 114 },
  Enquiry: { List: 118 },
  StudioRequested: { List: 122, Edit: 123 },
  StudioRejected: { List: 130, Edit: 131 },
  Booking: { List: 132, StatusChange: 133 },
  BookingRequest: { List: 134, StatusChange: 135 },
  BookingRejected: { List: 136, StatusChange: 137 },
  Vendor: { List: 138 },
  VendorRequest: { List: 139, StatusChange: 140 },
  VendorRejected: { List: 141 },
  walleteHistory: { List: 142 },
  BulkUpload: {
    Country: 107,
    State: 108,
    City: 109,
    Pincode: 110,
    CountryCode: 111,
    Category: 112,
    SubCategory: 113,
  },
};
